import { differenceInDays, format, formatDistanceToNow, parseISO } from 'date-fns';

export function formatDate(dateString: string | null): string {
  if (!dateString) {
    return 'TBD';
  }

  try {
    const date = parseISO(dateString);
    return format(date, 'dd/MMM/yyyy');
  } catch (error) {
    console.error(`Failed to format date: ${dateString}`, error);
    return 'TBD';
  }
}

export function formatDateUTC(dateString: string | null): string {
  if (!dateString) {
    return '—';
  }

  try {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
  } catch (error) {
    console.error(`Failed to format UTC date: ${dateString}`, error);
    return '—';
  }
}

/**
 * Formats a number as currency (USD)
 * @param amount - Amount to format
 * @param showDecimals - Whether to show decimal places (default: false for dashboard, true for admin)
 */
export function formatCurrency(amount: number, showDecimals: boolean = false): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  }).format(amount);
}

/**
 * Returns integer and decimal parts for display (e.g. large amount with styled decimals).
 */
export function formatCurrencyForDisplay(amount: number): {
  integerPart: string;
  decimalPart: string;
} {
  const integerPart = new Intl.NumberFormat('en-US').format(Math.trunc(amount));
  const decimalPart = amount.toFixed(2).split('.')[1] ?? '00';
  return { integerPart, decimalPart };
}

export function formatDateFriendly(dateString: string | null): string {
  if (!dateString) return 'TBD';
  try {
    const date = parseISO(dateString);
    return format(date, 'MMMM do');
  } catch {
    return 'TBD';
  }
}

export function formatRelativeDate(dateString: string | null): string {
  if (!dateString) return '-';

  try {
    const date = parseISO(dateString);
    const daysDiff = differenceInDays(new Date(), date);

    if (daysDiff < 30) {
      return formatDistanceToNow(date, { addSuffix: true });
    }

    return format(date, 'yyyy-MM-dd');
  } catch {
    return '-';
  }
}
